class TabGroup extends HTMLElement {
	connectedCallback() {
		// We listen for events directly on the element
		this.addEventListener("click", this._handleClick);
		this.addEventListener("keydown", this._handleKeyDown);
	}

	_handleClick(e) {
		const tab = e.target.closest('[role="tab"]');
		if (tab) this._selectTab(tab);
	}

	_handleKeyDown(e) {
		const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
		const index = tabs.indexOf(document.activeElement);

		if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
			// Only rove focus between tabs when focus is on a tab, not in tabpanel
			// content (forms, text fields, etc.) that need native arrow key behavior.
			if (index < 0) return;
			e.preventDefault();
			const direction = e.key === "ArrowRight" ? 1 : -1;
			const nextIndex = (index + direction + tabs.length) % tabs.length;
			tabs[nextIndex].focus();
			this._selectTab(tabs[nextIndex]);
		}
	}

	_selectTab(selectedTab) {
		const tabs = this.querySelectorAll('[role="tab"]');
		const panels = this.querySelectorAll('[role="tabpanel"]');
		const targetId = selectedTab.getAttribute("aria-controls");

		tabs.forEach((tab) => {
			const isSelected = tab === selectedTab;
			tab.setAttribute("aria-selected", isSelected);
			tab.setAttribute("tabindex", isSelected ? "0" : "-1");

			// Toggle the anchor name for the sliding active tab indicator
			if (isSelected) {
				tab.style.setProperty("anchor-name", "--active-tab");
			} else {
				tab.style.removeProperty("anchor-name");
			}
		});

		panels.forEach((panel) => {
			panel.hidden = panel.id !== targetId;
		});

		this.dispatchEvent(
			new CustomEvent("tab-group:change", {
				bubbles: true,
				detail: {
					groupId: this.id || null,
					tabId: selectedTab.id || null,
					panelId: targetId,
				},
			}),
		);
	}
}

// Register the component
if (!customElements.get("tab-group")) {
	customElements.define("tab-group", TabGroup);
}
